import React, { useCallback } from "react";
import { observer } from "mobx-react-lite";
import { ScreenResponsive } from "../../components";
import { strings } from "../../localization";
import {
	Box,
	BoxedRow,
	ButtonLink,
	Circle,
	Grid,
	IconBalanceRegular,
	IconDollarSymbolCircleRegular,
	IconHeadphonesRegular,
	skinVars,
	Text3,
	Text6,
} from "@telefonica/mistica";
import { useGlobalStore } from "../../contexts/globalStoreContext";
import { onlyFirstName } from "../../utils/formatters";
import { useNavigateCustom } from "../../hooks";

const HomeLogged: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const {
		fintechRegisterStore: { name },
		authenticationStore,
	} = useGlobalStore();
	const { bodyText, title } = strings.pages.homeLogged;
	const { anticipateMyFGTS, myHires, callCenter, toGoOut } = strings.components.buttons;

	const onHandleToGoOut = useCallback(() => {
		authenticationStore.logout();
		navigation("/");
	}, []);

	return (
		<ScreenResponsive isFullHeight responsiveLayoutProps={{ backgroundColor: "#F6F6F6" }}>
			<Grid columns={1} justifyItems="center">
				<Box paddingY={40}>
					<Grid columns={{ maxSize: 600 }}>
						<Text6>{title(onlyFirstName(name.field.value))}</Text6>
						<Box padding={4} />
						<Text3 light color={"#666666"}>
							{bodyText}
						</Text3>
					</Grid>
				</Box>
				<Grid justifyItems="center">
					<Grid columns={{ maxSize: 392 }} gap={16}>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconDollarSymbolCircleRegular color={skinVars.colors.brand} />
								</Circle>
							}
							title={anticipateMyFGTS}
							onPress={() => navigation("/authorization-inquiry-balance")}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconBalanceRegular color={skinVars.colors.brand} />
								</Circle>
							}
							title={myHires}
							onPress={() => navigation("/list-of-contracts")}
						/>
						<BoxedRow
							asset={
								<Circle size={40} backgroundColor={skinVars.colors.brandLow}>
									<IconHeadphonesRegular color={skinVars.colors.brand} />
								</Circle>
							}
							title={callCenter}
							onPress={() => navigation("/call-center")}
						/>
					</Grid>
					<Box paddingTop={40}>
						<ButtonLink onPress={() => onHandleToGoOut()}>{toGoOut}</ButtonLink>
					</Box>
				</Grid>
			</Grid>
		</ScreenResponsive>
	);
});

export default HomeLogged;
